import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MainComponent} from './main/main.component';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import {ViewerComponent} from './viewer/viewer.component';
import {DataService} from './data.service';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule} from '@angular/forms';
import {ChartBoxComponent} from './chart-box/chart-box.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {InfoDialogComponent} from './info-dialog/info-dialog.component';
import {InfoCesiumBtnComponent} from './info-cesium-btn/info-cesium-btn.component';
import {ShareComponent} from './info-dialog/share/share.component';
import {DisclaimerBtnComponent} from './disclaimer-btn/disclaimer-btn.component';
import {DisclaimerDialogComponent} from './disclaimer-dialog/disclaimer-dialog.component';

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    ViewerComponent,
    ChartBoxComponent,
    InfoDialogComponent,
    InfoCesiumBtnComponent,
    ShareComponent,
    DisclaimerBtnComponent,
    DisclaimerDialogComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    HttpClientModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatSliderModule,
    MatButtonModule,
    DragDropModule,
    MatSelectModule,
    MatTooltipModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    MatDialogModule
  ],
  providers: [
    DataService,
    {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {hasBackdrop: true}}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
